import styled from 'styled-components';
import { Column, Row, TitleCard } from '../../styles';
import { Color, Breakpoints } from '~/styles';

export { Column, Row, TitleCard };

interface IPropsHistoryConsumer {
  eletronic_exists?: boolean;
}

export const Container = styled.div`
  width: 100%;
`;

export const ContainerHistoryConsumer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${Breakpoints.desktopLarge.max}px) {
    flex-direction: row;
    gap: 37px;
  }
`;

export const ContainerConfigureAlert = styled.div`
  width: 240px;
`;

export const HistoryConsumer = styled.div<IPropsHistoryConsumer>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (min-width: ${Breakpoints.desktopLarge.max}px) {
    width: ${({ eletronic_exists }) => (eletronic_exists ? '60%' : '100%')};
  }
`;

export const RowChart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TextIot = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  color: ${Color.grayLightSeconde};
  margin-bottom: 37px;
`;

export const SubtitleHistory = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
  position: relative;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.715px;
    height: 22px;
    color: ${Color.gray};
  }

  #legend {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    p {
      div {
        width: 10px;
        margin-right: 8px;
      }
    }
  }

  #total {
    align-self: center;
  }

  @media (min-width: ${Breakpoints.tablet.min}px) {
    #legend {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;

      p {
        margin-right: 10px;
        div {
          width: 10px;
          margin-right: 10px;
        }
      }
    }

    #total {
      align-self: flex-end;
      margin-right: 50px;
      p {
        font-weight: 500;
      }
    }
  }

  @media (min-width: ${Breakpoints.laptop.min}px) {
    flex-direction: row;
    justify-content: space-around;

    #legend {
      width: auto;
    }

    #total {
      margin: 0;
    }
  }
`;

export const ConfigureAlertButton = styled.button`
  width: 100%;
  height: 48px;
  display: flex;
  padding: 4px 13px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 2px solid ${Color.green};
  background: ${Color.green};
  color: ${Color.white};
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  margin-top: 24px;

  svg {
    margin-right: 12px;
  }

  @media (min-width: ${Breakpoints.desktopLarge.max}px) {
    display: none;
  }
`;

export const ContainerEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 370px;
`;
